import type {
  PublicSignerSessionResponse,
  PublicSignerSubmitRequest
} from '../publicSignerTypes';

import {
  buildPublicSignerFieldSnapshot,
  hasPublicSignerSignatureEntryValue
} from './buildFieldSnapshot';
import type { PublicSignerFieldDraftValues } from './types';

export function buildPublicSignerSubmitRequest(
  session: PublicSignerSessionResponse,
  fieldDraftValues: PublicSignerFieldDraftValues,
  isDisclosureAccepted: boolean
): PublicSignerSubmitRequest {
  const fields = buildPublicSignerFieldSnapshot(session, fieldDraftValues);

  return {
    ...(hasPublicSignerSignatureEntryValue(fields) && isDisclosureAccepted
      ? { disclosure_accepted: true }
      : {}),
    fields
  };
}
